Ext.define(null, {
	override: 'Ext.Component',
	/**
	 * 2020808 by wayne
	 * noLocale: 指示不做本地化转换
	 * localeType: 自定义本地化处理的转换类型
	 */
	config: {
		noLocale: false,
		localeType: ''
	},
});

Ext.define(null, {
	override: 'Ext.grid.column.Column',
	config: {
		locale: null
	}
})

Ext.define(null, {
	override: 'Ext.grid.cell.Text',

	updateRawValue: function (rawValue) {
		var me = this,
			dom = this.bodyElement.dom,
			value = rawValue == null ? '' : rawValue,
			locale = me.getColumn().getLocale?.()

		value = locale ? Tyan.t(value, locale) : value
		// value = Tyan.t(value)

		if (this.getEncodeHtml()) {
			dom.textContent = value;
		}
		else {
			dom.innerHTML = value;
		}
	}
})

Ext.define(null, {
	override: 'Ext.tip.Manager',
	config: {
		overflowTip: {
			align: 'l-r?',
			anchor: true,
			showOnTap: true,
			noLocale: true
		}
	},
	/**
	 * 20200817 by wayne，为qtip指定 noLocale 默认false
	 * 20250811 by wayne, 为qtip指定 noLocale 读取 data-qnolocale属性 
	 */
	privates: {
		_propertyMap: (function () {
			var numFn = function (v) { return parseInt(v, 10) },
				boolFn = function (v) { return !!v },
				fn = Ext.identityFn

			return {
				noLocale: { prop: 'data-qnolocale', parse: boolFn },
				ui: { prop: 'data-qui', parse: fn },
				html: { prop: 'data-qtip', parse: fn },
				width: { prop: 'data-qwidth', parse: numFn },
				minWidth: { prop: 'data-qminWidth', parse: fn },
				maxWidth: { prop: 'data-qmaxWidth', parse: fn },
				title: { prop: 'data-qtitle', parse: fn },
				autoHide: { prop: 'data-qautoHide', parse: boolFn },
				cls: { prop: 'data-qcls', parse: fn },
				axisLock: { prop: 'data-axislock', parse: fn },
				align: { prop: 'data-qalign', parse: fn },
				alignDelegate: { prop: 'data-qaligndelegate', parse: fn },
				anchor: { prop: 'data-qanchor', parse: fn },
				showDelay: { prop: 'data-qshowDelay', parse: numFn },
				hideDelay: { prop: 'data-qhideDelay', parse: numFn },
				dismissDelay: { prop: 'data-qdismissDelay', parse: numFn },
				trackMouse: { prop: 'data-qtrackMouse', parse: boolFn },
				anchorToTarget: { prop: 'data-qanchorToTarget', parse: boolFn },
				allowOver: { prop: 'data-qallowover', parse: boolFn },
				closable: true,
				// noLocale: false,
				localeType: '',
			};
		})()
	},
});

// Ext.MessageBox message 根据参数messageNoLocale来决定是否做本地化处理
Ext.define(null, {
	override: 'Ext.MessageBox',
	config: {
		messageNoLocale: false,
	},
	applyMessage: function (config) {
		config = {
			noLocale: this.getMessageNoLocale(),
			html: config,
			cls: this.baseCls + '-text'
		};

		return Ext.factory(config, Ext.Component, this._message);
	}
});

Ext.define(null, {
	override: 'Ext.Panel',
	/**
	 * 2020817 by wayne, 所有默认按钮文本不做翻译(通过Ext.define处理)
	 */
	config: {
		standardButtons: {
			ok: { noLocale: true },
			abort: { noLocale: true },
			retry: { noLocale: true },
			ignore: { noLocale: true },
			yes: { noLocale: true },
			no: { noLocale: true },
			cancel: { noLocale: true },
			apply: { noLocale: true },
			save: { noLocale: true },
			submit: { noLocale: true },
			help: { noLocale: true },
			close: { noLocale: true }
		},
	}
}, function () {
	Ext.Msg && (Ext.Msg.destroy(), Ext.Msg = new Ext.MessageBox({ id: 'ext-messagebox' }))
});

; (function () {
	const noLocaleArr = ['Title'];

	const localeArr = [
		['Component', 'Html', 'html'],
		['Button', 'Text', 'button'],
		['field.Checkbox', 'BoxLabel', 'boxlabel'],
		['field.Field', 'Label', 'label'],
		['field.Input', 'Placeholder', ''],
		// ['field.Input', 'RequiredMessage', 'label'],
		['form.FieldSet', 'Title', 'fieldsetTitle'],
		['field.Radio', 'BoxLabel', 'boxlabel'],
		['grid.column.Column', 'Text', 'columnText'],
		// ['menu.Item', 'Text', 'menuItem'],
		['MessageBox', 'Title', 'msgboxTitle'],
		['Panel', 'Title', 'panelTitle'],
		['TitleBar', 'Title', 'titlebarTitle']
	];

	noLocaleArr.forEach(function (name) {
		Ext.define(null, {
			override: `Ext.${name}`,
			config: {
				noLocale: true,
				// localeType: ''
			},
		})
	})

	localeArr.forEach(function ([name, field, localeType]) {
		Ext.define(null, {
			override: `Ext.${name}`,
			[`apply${field}`]: function (arg) {
				const type = this.getLocaleType()
				if (type && localeType && type !== localeType)
					return arg
				localeType && this.setLocaleType(localeType)
				arg = !this.getNoLocale() && arg && typeof arg === 'string' ? Tyan.t(arg, this.getLocaleType() || localeType, name, field) : arg

				var method
				method = (method = this[`apply${field}`]) && (method.$previous ||
					((method = method.$owner ? method : method.caller) &&
						method.$owner.superclass.self[method.$name]))

				arg = method ? method.apply(this, [arg]) : arg

				return arg
			}
		})
	})
})();

// 2025/6/6 by wayne
// Grid 分组显示内容继承了Component.html，需要默认不做本地化处理，如果Column有locale配置，则根据配置做本地化处理
// 因未知的原因，无法在GetGroupHeaderTplData中调用callSuper，所以复制了RowHeader及 ItemHeader的getGroupHeaderTplData方法进行组合重写
// 参考 node_modules/%40sencha/ext-modern/src/grid/RowHeader.js
// 参考 node_modules/%40sencha/ext-modern/src/dataview/ItemHeader.js
Ext.define(null, {
	override: 'Ext.grid.RowHeader',
	config: { noLocale: true },
	privates: {
		getGroupHeaderTplData: function () {
			var group = this.getGroup(),
				list = this.parent,
				data = group && {
					name: group.getGroupKey(),
					group: group,
					groupField: list.getStore().getGrouper().getProperty(),
					children: group.items,
					count: group.length
				};

			if (data) {
				data.value = group.items[0]?.data[data.groupField];
			}

			// For Classic compat:
			data.groupValue = data.value;

			var //data = this.callSuper([ /* skipHtml= */true]),
				grid = this.parent,
				partners = grid.allPartners || [grid],
				len = partners.length,
				i, p, column,
				locale;

			if (data) {
				for (i = 0; i < len; ++i) {
					p = partners[i];
					column = p.getColumnForField(data.groupField);

					if (column) {
						break;
					}
				}
			}

			if (column) {
				data.columnName = column.getText();

				if (column.printValue) {
					data.html = column.printValue(data.value);
				}
				locale = column.getLocale?.()
			}
			else if (data) {
				data.html = Ext.htmlEncode(data.name);
			}

			locale && (data.html = Tyan.t(data.html, locale))

			return data;
		}
	}

});